import React from "react";
import "../../../css/TotalRental.css";
import mobility from "../../../img/ride.png";

interface TotalRentalProps {
  TotalRental: number;
}

const TotalRental = ({ TotalRental }: TotalRentalProps) => {
  return (
    <div className="rental_amount_container">
      <div className="rental_display">
        <img className="mobility" src={mobility} />
        <div className="rental_amount_title">累計レンタル件数</div>
      </div>
      <div className="rental_amount_of">
        {TotalRental}
        <span className="unit">件</span>
      </div>
    </div>
  );
};

export default TotalRental;
